<template>
  <div>
    Future Occlusion option
  </div>
</template>
<script>
export default {
  name: 'CardTypeOcclusion',
  data() {
    return {

    }
  }
}
</script>
